import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { QuoteStatusDescriptionPipe } from './quote-status-description.pipe';
import { QuoteStatusIconPipe } from './quote-status-icon.pipe';
import { QuoteStatusColorPipe } from './quote-status-color.pipe';

@NgModule({
  imports: [
    CommonModule,
    QuoteStatusDescriptionPipe,
    QuoteStatusIconPipe,
    QuoteStatusColorPipe,
  ],
  exports: [
    QuoteStatusDescriptionPipe,
    QuoteStatusIconPipe,
    QuoteStatusColorPipe,
  ],
  providers: [
    QuoteStatusDescriptionPipe,
    QuoteStatusIconPipe,
    QuoteStatusColorPipe,
  ],
})
export class QuoteStatusPipesModule {}
